/**
 * Created by Ning Jiang on 2024-05-31.
 */
import {WinPresentationController} from "../WinPresentationController";
import {DeadwoodRip} from "../../DeadwoodRip";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DeadwoodRipS2Symbol} from "../../symbol/DeadwoodRipS2Symbol";
import {TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";
import {RetriggerS1Symbol} from "../../symbol/RetriggerS1Symbol";

export class FreespinUpgradeController extends WinPresentationController {

    constructor() {
        super("FreespinUpgradeController", false);

        if(DeadwoodRip.model.isRestore && DeadwoodRip.model.data.nextMode === GameMode.FREESPIN_SUPER) {
            const s2 = <DeadwoodRipS2Symbol>DeadwoodRip.reels[4].getSymbol(0);
            s2.resetSuperFS();
        }
    }

    protected hasWin():boolean {
        const data = DeadwoodRip.model.parsedGameData;
        return (data.mode === GameMode.FREESPIN && data.nextMode === GameMode.FREESPIN_SUPER);
    }

    protected async createWinAnimation():Promise<any> {
        const tl = new TimelineLite();
        tl.add(() => {
            DeadwoodRip.initialCountUp.remove();
            DeadwoodRip.bigWinCountUp.remove();
            DeadwoodRip.waysWon.remove();
            SlotGame.keypadPlugin.hide();
        });

        const s2 = <DeadwoodRipS2Symbol>DeadwoodRip.reels[4].getSymbol(0);
        tl.add([
            () => {
                DeadwoodRip.reels[4].reelView.addWinSymbol(s2);
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S2_WIN});
            },
            s2.playWinSuper()
        ]);
        let delay = 1;

        let s1Amount = 0;
        DeadwoodRip.model.parsedGameData.S1Positions!.forEach((symId, reelId) => {
            if(symId > -1) {
                s1Amount++;
            }
        });

        if(s1Amount === 3) {
            DeadwoodRip.model.parsedGameData.S1Positions!.forEach((symId, reelId) => {
                if(symId > -1) {
                    const symbol = <RetriggerS1Symbol>DeadwoodRip.reels[reelId].getSymbol(symId);
                    tl.add([
                        () => {
                            DeadwoodRip.reels[reelId].reelView.addWinSymbol(symbol);
                        },
                        symbol.playRetrigger()
                    ], delay);
                    delay += 0.5;
                }
            });
            // if(hasS1) {
            //     tl.add(() => {
            //         DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S1_WIN});
            //     }, 0);
            // }
        }

        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            DeadwoodRip.freespinIntro.show(() => {
                SlotGame.keypadPlugin.setZeroBetSpinCounter(DeadwoodRip.model.parsedGameData.freespinsLeft);
                resolve();
            });
        });
    }
}